import { InternalWorkoutReview, WorkoutSelection, WorkoutSelectionStatus } from '../../../entities';
import { IWorkoutSelectionRepository } from '../interfaces';

export class CachedWorkoutSelectionRepository implements IWorkoutSelectionRepository {
    private static Cached: WorkoutSelection[];
    private static CachedIdMap: Map<string, WorkoutSelection>;
    constructor(private underlyingWorkoutSelectionRepository: IWorkoutSelectionRepository) { }

    public async createCache(): Promise<WorkoutSelection[]> {
      return this.getAll();
    }

    public async getAll(): Promise<WorkoutSelection[]> {
        if (!CachedWorkoutSelectionRepository.Cached || CachedWorkoutSelectionRepository.Cached.length === 0) {
            CachedWorkoutSelectionRepository.Cached = await this.underlyingWorkoutSelectionRepository.getAll();
            CachedWorkoutSelectionRepository.CachedIdMap = new Map<string, WorkoutSelection>();
            for (const workoutSelection of CachedWorkoutSelectionRepository.Cached) {
              const key = this.getGuaranteedToBeStringOrUndefined(workoutSelection.uniqueReference);
              if (key != null) {
                CachedWorkoutSelectionRepository.CachedIdMap.set(key, workoutSelection);
              }
            }
        }
        return [...CachedWorkoutSelectionRepository.Cached];
    }

    public async get(uid: string): Promise<WorkoutSelection | undefined> {
        await this.getAll();
        const key = this.getGuaranteedToBeStringOrUndefined(uid);
        if (key != null) {
          const workoutSelection = CachedWorkoutSelectionRepository.CachedIdMap.get(key);
          return workoutSelection ? this.createDeepCopy(workoutSelection) : undefined;
        }
        return undefined;
    }

    public add(workoutSelection: WorkoutSelection): Promise<WorkoutSelection> {
        throw new Error('Method not implemented.');
    }
    public update(workoutSelection: WorkoutSelection): Promise<WorkoutSelection> {
        throw new Error('Method not implemented.');
    }
    public addReview(workoutId: string, review: InternalWorkoutReview): Promise<void> {
        throw new Error('Method not implemented.');
    }
    public addPowerReview(workoutId: string, review: InternalWorkoutReview): Promise<void> {
        throw new Error('Method not implemented.');
    }
    public filter(status: WorkoutSelectionStatus, from: number, to: number): Promise<WorkoutSelection[]> {
        throw new Error('Method not implemented.');
    }

    public resetCache() {
      CachedWorkoutSelectionRepository.Cached = [];
    }

    private createDeepCopy(obj: any) {
      return JSON.parse(JSON.stringify(obj));
    }

    private getGuaranteedToBeStringOrUndefined(id: string): string | undefined {
      if (id == null) {
        return undefined;
      }
      return id.toString();
    }
}
